import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Campaign, CampaignGivingSpace } from '@givebutter/types';
import { FetchLiveDisplayCampaignParams, fetchLiveDisplayCampaign } from 'api/livedisplay';

const useLiveDisplayCampaign = ({
  campaignSlug,
}: FetchLiveDisplayCampaignParams): UseQueryResult<Campaign, Error> => {
  return useQuery<Campaign, Error, Campaign>(
    ['campaigns', campaignSlug, 'livedisplay'],
    () => {
      return fetchLiveDisplayCampaign({ campaignSlug });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  );
};

const applyGivingSpaceCreated = (
  campaign: Campaign | undefined,
  space: CampaignGivingSpace,
): Campaign => {
  const isDonation = Number.parseInt(space.donation_amount, 10) !== 0;
  const spaces = campaign?.spaces ?? [];

  return {
    ...campaign,
    donors: space.campaign?.supporters,
    raised: space.campaign?.raised,
    raised_percentage: space.campaign?.raised_percentage,
    spaces: isDonation ? [space, ...spaces] : spaces,
  } as Campaign;
};

export { applyGivingSpaceCreated, useLiveDisplayCampaign };
